import { render, staticRenderFns } from "./VueDataTableV2.vue?vue&type=template&id=6fd1799a&scoped=true"
import script from "./VueDataTableV2.vue?vue&type=script&lang=js"
export * from "./VueDataTableV2.vue?vue&type=script&lang=js"
import style0 from "./VueDataTableV2.vue?vue&type=style&index=0&id=6fd1799a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd1799a",
  null
  
)

export default component.exports